import { createSlice } from '@reduxjs/toolkit';

import { Task } from './sageAdminApi';
import { TaskStatuses } from 'src/constants/TaskStatuses';

type TrainingState = {
    trainingAlert: Task | undefined;
    isGuidedTour: boolean;
};

export const initialState: TrainingState = {
    trainingAlert: undefined,
    isGuidedTour: false,
};

export const TrainingSlice = createSlice({
    name: 'training',
    initialState,
    reducers: {
        setTrainingAlert: (state, { payload }) => {
            state.trainingAlert = payload;
        },
        cancelConfirmation: (state) => {
            if (state.trainingAlert) {
                state.trainingAlert.status = TaskStatuses.OpenClaimed.id;
            }
        },
        setIsGuidedTour: (state, { payload }) => {
            state.isGuidedTour = payload;
        },
    },
    selectors: {
        selectTrainingAlert: (sliceState: TrainingState) => sliceState.trainingAlert,
        selectIsGuidedTour: (sliceState: TrainingState) => sliceState.isGuidedTour,
    },
});

// Action creators are generated for each case reducer function
export const { setTrainingAlert, cancelConfirmation, setIsGuidedTour } = TrainingSlice.actions;

export const { selectTrainingAlert, selectIsGuidedTour } = TrainingSlice.selectors;

export default TrainingSlice.reducer;
